import { Minus } from 'lucide-react';
import { parse } from 'date-fns';
import { useState } from 'react';
import styles from './style.module.css';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { DatePicker } from '@/components/common/DatePicker';
import { Button } from '@/components/ui/button';

// import data from '@/mock-data/week_scheduler_data.json';
import { useNavigate, useParams } from 'react-router-dom';
import {
  DAYS_OF_WEEK,
  ALL_TIME_SLOTS,
} from '@/pages/DoctorManagementPage/constants';

interface TimeOption {
  value: string;
  label: string;
}

const timeToDate = (time: string): number => {
  const [hour, minutePart] = time.split(':');
  const [minute, period] = minutePart.split(' ');
  const date = parse(`${hour}:${minute} ${period}`, 'hh:mm a', new Date());
  return date.getTime();
};

const filterEndTimeOptions = (selectedTime: string | null): TimeOption[] => {
  if (!selectedTime)
    return ALL_TIME_SLOTS.map((time) => ({ value: time, label: time }));

  const selectedTimeValue = timeToDate(selectedTime);
  return ALL_TIME_SLOTS.filter(
    (time) => timeToDate(time) > selectedTimeValue
  ).map((time) => ({ value: time, label: time }));
};

export function EditAvailability() {
  const [startTime, setStartTime] = useState<string | null>(null);
  const [endTime, setEndTime] = useState<string | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const { id } = useParams();

  const navigate = useNavigate();

  const handleStartTimeChange = (option: string) => {
    setStartTime(option ? option : null);
    setEndTime(null);
  };

  const handleEndTimeChange = (option: string) => {
    setEndTime(option ? option : null);
  };

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date ?? null);
  };

  const handleCancelClick = () => {
    navigate(`/doctor-management/${id}/manage-appointment`);
  };

  const handleDeleteSchedule = () => {};

  return (
    <>
      <div
        className="w-full overflow-x-auto px-6 py-7"
        style={{
          background: '#FFF',
        }}
      >
        <div className={styles['manage-availability-header-container']}>
          <div className="flex flex-col w-full">
            <p className={styles['manage-availability-heading']}>
              Manage Availability
            </p>
            <div className="flex flex-col md:flex-row md:flex-wrap justify-between w-full gap-8 mt-10">
              <div>
                <p className="text-base font-medium mb-[30px]">
                  SET WORKING DAYS
                </p>
                <div className="flex gap-2.5 w-full">
                  <DatePicker
                    className="w-full"
                    selectedDate={startDate!}
                    onSelectDate={handleStartDateChange}
                    inline
                    dateFormat="dd/MM/yyyy"
                    placeholder="Enter start date"
                    buttonText="Enter start date"
                  />
                </div>
              </div>
              <div>
                <p className="text-base font-medium mb-[30px]">
                  SET WORKING HOURS
                </p>

                {DAYS_OF_WEEK.map((day) => (
                  <div key={day} className="flex items-center gap-2.5 mb-2.5">
                    <div>
                      <div className="w-[150px] flex items-center">
                        <Checkbox
                          id={day.toLowerCase()}
                          name={day.toLowerCase()}
                        />

                        <label
                          htmlFor={day.toLowerCase()}
                          style={{ marginLeft: '10px' }}
                        >
                          {day}
                        </label>
                      </div>
                    </div>

                    <div className="relative outline-[none] flex flex-row gap-5 items-center">
                      <Select>
                        <SelectTrigger
                          className={`${styles['manage-booking-dropdown-outline']} w-[112px]`}
                        >
                          <SelectValue placeholder="Start time" />
                        </SelectTrigger>
                        <SelectContent>
                          {ALL_TIME_SLOTS.map((time, index) => (
                            <SelectItem
                              onClick={() => handleStartTimeChange(time)}
                              value={time}
                              key={`select-dropdown-${time}-${index}`}
                            >
                              {time}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>

                      <Minus color="#71717A" />

                      <Select>
                        <SelectTrigger
                          className={`${styles['manage-booking-dropdown-outline']} w-[112px]`}
                        >
                          <SelectValue placeholder="End time" />
                        </SelectTrigger>
                        <SelectContent>
                          {filterEndTimeOptions(startTime).map(
                            ({ value, label }, index) => (
                              <SelectItem
                                onClick={() => handleEndTimeChange(value)}
                                value={value}
                                key={`select-dropdown-${value}-${index}`}
                              >
                                {label}
                              </SelectItem>
                            )
                          )}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-between mt-5">
        <div>
          <Button
            variant="gray"
            className="focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            onClick={handleDeleteSchedule}
          >
            Delete Schedule
          </Button>
        </div>
        <div className="flex flex-row gap-3 justify-end ">
          <Button
            onClick={handleCancelClick}
            variant="destructive"
            className="focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Cancel
          </Button>
          <Button
            variant="gray"
            onClick={() =>
              alert(
                `Start time: ${startTime}; End time: ${endTime}; Start date: ${startDate};`
              )
            }
          >
            Set availability
          </Button>
        </div>
      </div>
    </>
  );
}
